<app-page-shell
  title="Dashboard"
  description="Overview of platform activity, onboarding status, and subscription health."
  badge="Overview"
>
  <div class="dashboard-stats">
    @for (stat of stats; track stat.label) {
      <article class="stat-card">
        <span class="stat-card__label">{{ stat.label }}</span>
        <strong class="stat-card__value">{{ stat.value }}</strong>
        <span class="stat-card__hint">{{ stat.hint }}</span>
      </article>
    }
  </div>

  <div class="dashboard-panels">
    <section class="panel-card">
      <h3>Quick access</h3>
      <ul class="quick-links">
        @for (link of quickLinks; track link.route) {
          <li>
            <a [routerLink]="link.route">{{ link.label }}</a>
          </li>
        }
      </ul>
    </section>

    <section class="panel-card panel-card--accent">
      <h3>Getting started</h3>
      <p>
        Admin modules are scaffolded and ready. Connect each section to the API to load live
        enterprise, plan, and feature data from icxbee-bo services.
      </p>
    </section>
  </div>

  
</app-page-shell>
